<template>
  <Complete></Complete>
</template>

<script>
export default {
  name: 'NewRegistrationComplete',
  components: {
    Complete: () => import('../../components/cloud/UserRegistration/Complete.vue')
  },
  props: {
    reg: Object
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name === 'new-registration-confirm' && vm.reg.editState === 'confirmed'){
        vm.$emit('initReg')
        next()
        return;
      }
      next({ name: 'new-registration' })
    })
  }
}
</script>

<style scoped>
</style>